import './styles.scss';
import { Handle, Position } from '@xyflow/react';
import { IconTrash } from '@tabler/icons-react';
import { Text } from '@fragments';

export default function StepNode({ data }) {
    return (
        <div className={`step-node${data.isSelected ? ' step-node--selected' : ''}`}>
            <Handle
                type="target"
                position={Position.Top}
                style={{ background: 'var(--surface-6)', width: 8, height: 8 }}
            />

            <div className="step-node-header">
                <span className="step-number-badge">{data.stepNumber}</span>
                <Text.span contrast={8} className="step-label">{data.title}</Text.span>
                <button
                    className="step-delete-btn"
                    data-action="delete"
                    title="Remover bloco"
                >
                    <IconTrash size={13} />
                </button>
            </div>

            <div className="step-node-body">
                <Text.span contrast={4}>
                    {data.questions?.length > 0
                        ? `${data.questions.length} pergunta${data.questions.length !== 1 ? 's' : ''}`
                        : 'Nenhuma pergunta ainda'}
                </Text.span>
            </div>

            <Handle
                type="source"
                position={Position.Bottom}
                style={{ background: 'var(--surface-6)', width: 8, height: 8 }}
            />
        </div>
    );
}
